import * as React from 'react';
import {Subject}  from 'rxjs';

import {PLAYER_SETTINGS_CONTAINER} from '../../../../Shared/Constants/TestIds';
import IUiEventsStreamPayload      from '../../../../Shared/Interfaces/IUiEventsStreamPayload';
import renderTestId                from '../../../Util/renderTestId';
import CaptionsMenu                from '../CaptionsMenu';

import * as styles   from './container.css';
import SettingsClose from './SettingsClose';

interface IContainerProps {
    uiEvents$: Subject<IUiEventsStreamPayload>;
    isSettingsOpen: boolean;
}

class Container extends React.Component<IContainerProps> {
    public shouldComponentUpdate(nextProps: IContainerProps): boolean {
        return this.props.isSettingsOpen !== nextProps.isSettingsOpen;
    }

    public render(): JSX.Element {
        const {isSettingsOpen, uiEvents$} = this.props;

        if (!isSettingsOpen) return null;

        return (
            <div
                className={styles.container}
                data-test-id={renderTestId(PLAYER_SETTINGS_CONTAINER)}
            >
                <CaptionsMenu uiEvents$={uiEvents$} />
                <SettingsClose uiEvents$={uiEvents$} />
            </div>
        );
    }
}

export default Container;